import React from 'react';
import '../../App.css';
import CalendarGrid from '../../components/CalendarGrid/CalendarGrid';

const Home: React.FC = () => {
  return (
    <div className="App">
      <header className="app-header">
        <div className="logo-container">
          <img 
            src="/logo-union-vert-white.png" 
            alt="Union Vovinam" 
            className="header-logo union-logo"
          />
        </div>
        <div className="title-container">
          <h1 className="main-title">Calendrier des événements Union Vovinam Viet Vo Dao France</h1>
          <h2 className="subtitle">Saison sportive 2025-2026</h2>
        </div>
        <div className="logo-container">
          <img 
            src="/logo-vovinam.png" 
            alt="Vovinam" 
            className="header-logo vovinam-logo"
          />
        </div>
      </header>
      <CalendarGrid />
    </div>
  );
};

export default Home;
